import * as React from "react";
import * as MD from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { I18N } from "../../Store/I18n/Types";
import { DrawSelect } from "./DrawSelect";

const useStyles = MD.makeStyles({
    autocompleteInput: {
        "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'][class*='MuiOutlinedInput-marginDense']": {
            padding: "2px",
        },
    },
});

interface IFilterProps {
    list: any[];
    listID: number[] | null;
    listStr: string[];
    allListIDs: number[];
    allListStr: string[];
    isAllSelected?: boolean;
    multiple?: boolean;
    saveChanges: (ids: number[], str: string[], isAllSelected: boolean) => void;
}

interface IProgramNameFilterProps {
    programName: string;
    emissions: string[];
    isLoading: boolean;
    onInputChange: (event: any, value: string) => void;
    onChange: (event: any, value: string | null) => void;
}

interface FiltersSectionProps {
    i18n: I18N;
    mediaFilter?: IFilterProps;
    mediaTitle?: string;
    programTypeFilter?: IFilterProps;
    programTypeTitle?: string;
    programEditorFilter?: IFilterProps;
    programEditorTitle?: string;
    programNameFilter?: IProgramNameFilterProps;
    programNameTitle?: string;
}

const DEFAULT_TITLE = {
    medias: "Medias",
    programTypes: "Program types",
    programEditors: "Program editors",
    programName: "Nom de l'émission...",
};

export const FiltersSection: React.FC<FiltersSectionProps> = ({
    i18n,
    mediaFilter,
    mediaTitle = DEFAULT_TITLE.medias,
    programTypeFilter,
    programTypeTitle = DEFAULT_TITLE.programTypes,
    programEditorFilter,
    programEditorTitle = DEFAULT_TITLE.programEditors,
    programNameFilter,
    programNameTitle = DEFAULT_TITLE.programName,
}) => {
    const classes = useStyles();
    const renderDrawSelect = (
        title: string,
        filter?: IFilterProps,
        multiple: boolean = true
    ) => {
        if (!filter || filter.listID === null) {
            return null;
        }

        return (
            <DrawSelect
                i18n={i18n}
                title={title}
                list={filter.list}
                listID={filter.listID}
                listStr={filter.listStr}
                allListIDs={filter.allListIDs}
                allListStr={filter.allListStr}
                isAllSelected={filter.isAllSelected ?? false}
                saveChanges={filter.saveChanges}
                multiple={multiple}
            />
        );
    };

    const renderProgramNameAutocomplete = (filter?: IProgramNameFilterProps) => {
        if (!filter) {
            return null;
        }

        return (
            <MD.FormControl className={classes.autocompleteInput} style={{ width: "100%", marginTop: "5px", padding: "5px 10px 5px 10px", marginBottom: "10px" }}>
                <Autocomplete
                    freeSolo
                    value={filter.programName}
                    loading={filter.isLoading}
                    options={filter.emissions}
                    getOptionLabel={(option) => option}
                    noOptionsText={i18n._("No options")}
                    onChange={filter.onChange}
                    onInputChange={filter.onInputChange}
                    renderInput={(params) => (
                        <MD.TextField
                            {...params}
                            variant="outlined"
                            size="small"
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        {filter.isLoading ? (
                                            <MD.CircularProgress color="inherit" size={20} />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }}
                            placeholder={programNameTitle}
                        />
                    )}
                    ListboxProps={{
                        style: {
                            maxHeight: "200px",
                            fontSize: "13px",
                        },
                    }}
                />
            </MD.FormControl>
        );
    };

    return (
        <>
            {renderDrawSelect(mediaTitle, mediaFilter)}
            {renderDrawSelect(programTypeTitle, programTypeFilter)}
            {renderDrawSelect(programEditorTitle, programEditorFilter)}
            {renderProgramNameAutocomplete(programNameFilter)}
        </>
    );
};


